import styled from '@emotion/styled';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  WithoutCollidingProps,
} from '../../theming';
import shouldForwardProp from '@styled-system/should-forward-prop';

export interface BaseInputProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    TypographyProps {}

type NonCollidingInputKeys = WithoutCollidingProps<BaseInputProps, 'input'>;

export const Input = styled<'input', keyof NonCollidingInputKeys>('input', {
  shouldForwardProp: (prop): prop is keyof NonCollidingInputKeys =>
    shouldForwardProp(prop as keyof NonCollidingInputKeys),
})<BaseInputProps>(
  defineWithTheme('inputs'),
  compose(background, border, color, position, shadow, space, typography)
);

export type InputProps = React.ComponentPropsWithoutRef<typeof Input>;
